import { CalendarPage } from "../components/Calendar/Calendar";

const Calendar: React.FC = () => {
  return <CalendarPage />;
};

export default Calendar;
